export type UnitSystem = 'SI Unit System' | 'Field';

import {Pipe, PipeTransform} from '@angular/core';
import {formatNumber} from '@angular/common';

export enum UnitType {
  KgPerM3 = 'kg/m3',
  CubicMeter = 'm3',
  CpTimesSnMinus1 = 'cp*sn-1',
  Celsius = 'C',
  CelsiusPer100m = 'C/100m',
  WattsPerMeterCelsius = 'W/mC',
  TCoeff = 'tCoeff',
  PCoeff = 'pCoeff',
  JPerKgCelsius = 'j/kgC',
  LitPerMin = 'lpm',
  GallonsPerMin = 'glpm',
  Pascal = 'Pa',
  KgPerMeter = 'kg/m',
  CubicMeterPerStk = 'm3/stk',
  KPaPerMeter = 'kPa/m',
  KPa = 'kPa',
  Millimeter = 'mm',
  One32ndOfMillimeter = '1/32 mm',
  CubicMeterPerMin = 'm3/min',
  MeterPerMin = 'm/min',
  Liter = 'lit',
  SquareMillimeter = 'mm2',
  MeterPerSec = 'm/sec',
  MeterPerHour = 'm/hr',
  Meter = 'm',
  NewtonMeter = 'N-m',
  NNMeter = 'NN-m',
  DaN = 'daN',
  Percentage = '%',
  Hours = 'hr',
  Min = 'min',
  RPM = 'rpm',
  PaSecCp = 'paSec_cp',
  MeterPerMinPerSec = 'm/min/s',
  Empty = '',
}

@Pipe({
  name: 'unitParse'
})
export class UnitParsePipe implements PipeTransform {

  constructor() {}

  transform(value: any, unit: UnitType | string, unitSystem: string, defaultUnit: string, zeroBegin = false, byPass = false, hasFormat = true, decimalZero = false, decimalNumber?: number) {

    if (unitSystem === 'SI Unit System' || unitSystem === '0' || unitSystem === 'Metric') {
      unitSystem = 'SI Unit System';
    }
    if (unitSystem === '1') {
      unitSystem = 'Field';
    }
    if (defaultUnit === 'SI Unit System') {
      defaultUnit = 'SI';
    }
    if (defaultUnit === '0') {
      defaultUnit = 'SI';
    }
    if (defaultUnit === '1') {
      defaultUnit = 'Field';
    }

    switch (unit) {
      case 'kg/m3' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 0.0083454), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.008345), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'glpm' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value / 3.7854117839), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value * 3.7854117839), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'm3' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 6.28981), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 6.28981), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'm3/stk' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 6.28981), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 6.28981), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'cp*sn-1' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 1000), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 1000), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'C' : {
        if (unitSystem === 'Field') {

          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue(((value * (9 / 5)) + 32), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value - 33.800072), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'C/100m' : {
        if (unitSystem === 'Field') {

          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 0.549), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.549), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'lpm' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 264.172), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          return this.formatValue((value * 1000), hasFormat, decimalZero, decimalNumber);
        }
      }
      case 'Pa' : {

        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue(((value * 0.020885434273039) * 100), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.020885434273039) * 100, hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'W/mC' : {
        if (unitSystem === 'Field' || byPass) {
          if (defaultUnit !== 'Field') {
            return this.formatValue((value * 0.57817598), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.57817598), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'tCoeff' : {
        if (unitSystem === 'Field' || byPass) {
          if (defaultUnit !== 'Field') {
            return this.formatValue((value * 0.57817598), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.57817598), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'j/kgC' : {
        if (unitSystem === 'Field' || byPass) {
          if (defaultUnit !== 'Field') {
            return this.formatValue((value * 0.000238846), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.000238846), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'kg/m' : {
        if (unitSystem === 'Field' || byPass) {
          if (defaultUnit !== 'Field') {
            return this.formatValue((value * 0.671968975), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.671968975), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'kPa/m' : {
        if (unitSystem === 'Field' || byPass) {
          if (defaultUnit !== 'Field') {
            return this.formatValue((value * 0.0442075), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.0442075), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'kPa' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            /*console.log();*/
            return this.formatValue((value * 0.145038), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.145038), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'mm' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value / 25.4), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value * 25.4), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case '1/32 mm' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value / 0.7938), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value * 0.7938), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'm3/min' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 264.172), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 264.172), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'paSec_cp' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 1000), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 1000), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'm/min' :
      case 'm/min/s' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 3.28084), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 3.28084), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'lit' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 0.264172), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.264172), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'mm2' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 0.00155), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.00155), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'm/sec' :
      case 'm/hr' :
      case 'm' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 3.28084), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 3.28084), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'N-m' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 0.737562 / 1000), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.737562), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'NN-m' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 0.737562), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 0.737562), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      case 'daN' : {
        if (unitSystem === 'Field') {
          if (defaultUnit !== 'Field' || byPass) {
            return this.formatValue((value * 2.2480894387096 / 1000), hasFormat, decimalZero, decimalNumber);
          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        } else {
          if (defaultUnit !== 'SI' || byPass) {
            return this.formatValue((value / 2.2480894387096), hasFormat, decimalZero, decimalNumber);

          } else {
            return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
          }
        }
      }
      default : {
        return this.formatValue(value, hasFormat, decimalZero, decimalNumber);
      }
    }
  }

  public formatValue(number: any, hasFormat, decimalZero, decimalNumber: number = 2) {
    if (hasFormat) {
      if (decimalZero) {
        return formatNumber(number, 'en-CA', '1.0-0');
      } else {
        return formatNumber(number, 'en-CA', '1.' + (0 + '-' + decimalNumber));
      }
    } else {
      if (decimalZero) {
        // @ts-ignore
        return Number(Math.round(number + 'e0') + 'e-0');
      } else {
        // @ts-ignore
        return Number(Math.round(number + ('e' + decimalNumber)) + ('e-' + decimalNumber));
      }
    }
  }
}


export function round(number) {
  // @ts-ignore
  return Number(Math.round(number + 'e1') + 'e-1');
}
